/* eslint-disable no-underscore-dangle */
import Logger from '../Logger/index.js';
import config from '../config/index.js';

let trackAudience;
const EVENT_STRING_DELIMITER = ' | ';
const { DEBUG } = config;

const tagNameToLabel = {
  A: 'link',
};

export const TRACKING_ELEMENT_TYPES = {
  ICON: 'icon',
  BUTTON: 'button',
  INPUT: 'input',
  FORM: 'form',
  INPUT_FILE: 'input_file',
};
export const TRACKING_ACTIONS = {
  CLICK: 'click',
  OPEN: 'open',
  CLOSE: 'close',
  ACCEPT: 'accept',
  INIT: 'initialised',
  SUBMIT: 'submit',
  VERIFY: 'verify',
  DELETE: 'delete',
  DOWNLOAD: 'download',
};

const trackingQueue = {
  push: value => {
    if (window._mtm) window._mtm.push(value);
    if (DEBUG === '1') Logger.log(`[tracking] ${JSON.stringify(value)}`);
  },
};

export function trackCustomEvent(data) {
  if (!data) return;
  const { eventCategory, eventAction } = data;
  if (!eventCategory || !eventAction)
    throw new Error('eventCategory and eventAction must be provided');
  const event = { ...data, event: 'custom_event' };
  trackingQueue.push(event);
}

export function trackEvent(
  event,
  payload = {
    action: null,
    zone: null,
    audience: null,
    elementType: null,
    actionText: null,
  },
) {
  let trackingParams = payload;
  const isEvent =
    event && (event.constructor.name === 'SyntheticBaseEvent' || event instanceof Event);

  if (arguments.length === 1 && !isEvent && typeof event === 'object') {
    trackingParams = event;
  }

  // eslint-disable-next-line consistent-return
  const getDataComponent = el => {
    let elm = el;
    // eslint-disable-next-line no-cond-assign
    while ((elm = elm.parentNode)) {
      if (elm.dataset.component) {
        return (
          (el.tagName.toLowerCase() === 'form' && el.dataset.component) || elm.dataset.component
        );
      }
    }
  };

  const el = event.currentTarget || event.target;
  const trackParams = {
    ...trackingParams,
    action: trackingParams.action || event.type,
    zone: trackingParams.zone || (el && getDataComponent(el)) || '',
    audience: trackingParams.audience === '' ? trackingParams.audience : trackAudience,
    actionText:
      trackingParams.actionText || trackingParams.actionText === ''
        ? trackingParams.actionText
        : (el && (el.innerText || el.title)) || '',
    elementType:
      trackingParams.elementType || trackingParams.elementType === ''
        ? trackingParams.elementType
        : (el && el.tagName && (tagNameToLabel[el.tagName] || el.tagName.toLowerCase())) || '',
  };

  const eventAction = [trackParams.zone, trackParams.elementType].join(EVENT_STRING_DELIMITER);
  const eventName = [trackParams.actionText, trackParams.audience].join(EVENT_STRING_DELIMITER);
  trackCustomEvent({
    eventCategory: 'user interactions',
    eventAction,
    eventName,
  });
}

export function trackPageView() {
  trackingQueue.push({ event: 'pageView' });
}

export function pushCustomDimensions({ userType, userId, clientVersion, isEmployee }) {
  trackingQueue.push({
    userType,
    userId,
    clientVersion,
    isEmployee,
  });
  trackAudience = userType;
}
